import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexCol, Heading } from '../../misc';

export const ScrollToWrapper = styled(FlexCol)`
  width: inherit;
  height: 100%;
  opacity: ${props => (props.hasHits ? 1 : 0)};
  transition: ${props => (props.hasHits ? 'opacity 0.2s linear' : 'none')};
  overflow-y: scroll;
  will-change: transform;
`;
export const NotFoundWrapper = styled(FlexCol)`
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: ${themeGet('space.4')}px;
`;

export const NotFoundHeading = styled(Heading)`
  color: ${themeGet('colors.greyDarkest')};
  opacity: 0.7;
  font-size: 18px;
  font-weight: 300;
  text-align: center;

  @media screen and (min-width: 40em) {
    font-size: 20px;
  }
`;

export const PaginationWrapper = styled('div')`
  width: 100%;
  padding: 8px;
  color: ${themeGet('colors.greyDarker')};

  .ais-Pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: ${themeGet('space.3')}px;
    border: none;
    border-radius: 0;
  }

  .ais-Pagination-list {
    display: flex;
    align-items: center;
    justify-content: center;
    list-style: none;
    width: 100%;
  }

  .ais-Pagination-item {
    display: flex;
    justify-content: center;
    align-items: cetner;
    background-color: #fff;
    width: 40px;
    height: 40px;
    border: 0.7px solid ${themeGet('colors.greyLight')};
    border-radius: 50%;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: background-color 0.15s ease-in;

    &:not(:last-child) {
      margin-right: 8px;
    }

    &:hover {
      background-color: ${themeGet('colors.greyLighter')};
    }
  }

  .ais-Pagination-link {
    text-decoration: underline;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .ais-Pagination-item--selected {
    background: ${themeGet('colors.red')};
    color: #fff;

    &:hover {
      background-color: ${themeGet('colors.redLight')};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/views/shop/style.js